var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-justify pt-2 red-line text-pre-wrap"},[_c('span',[_vm._v(_vm._s(_vm.template))])]),_c('div',{staticClass:"text-right"},[_c('v-btn',{staticClass:"mb-1",attrs:{"text":"","x-small":"","color":"success"},on:{"click":_vm.add}},[_vm._v("добавить")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }